import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';

/**
 * Reads whether mixed fare distribution by discount availability is enabled.
 *
 * @returns {boolean} Whether mixed fare distribution is enabled.
 */
const useMixDiscountFaresByAvailability = () => {
  const { MIX_DISCOUNT_FARES_BY_AVAILABILITY } = useWhitelabelFeatures() || {};

  return Boolean(MIX_DISCOUNT_FARES_BY_AVAILABILITY);
};

export default useMixDiscountFaresByAvailability;
